const Loader = () => {
    return (
        <div className="preloader" id="preloader">
            <div className="status d-flex justify-content-center align-items-center" id="status">
                <div className="spinner m-auto">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    );
};

export default Loader;
